import React from 'react'
import { Link, useNavigate } from 'react-router'
import BaseAuthenticatedMenu from './BaseAuthenticatedMenu'
import { Nav } from 'react-bootstrap'
import * as s from './Menu.scss'

const MainMenu = () => {

    const navigate = useNavigate()

    const navbarBrand = (       
        <Link to={{ pathname: '/main' }}>
            <span className={s.redHerringsWordmark}>REDHERRINGS</span>
        </Link>
    )

    const menuItems = [
        <Nav.Item className={s.item} key={1}><Nav.Link eventKey={1} onClick={() => navigate('/main')}>Pick a Contest</Nav.Link></Nav.Item>,
        <Nav.Item className={s.item} key={2}><Nav.Link eventKey={2} onClick={() => navigate('/main/register-contest')}>Register for a Contest</Nav.Link></Nav.Item>
    ]

    return (
        <BaseAuthenticatedMenu navbarBrand={navbarBrand} 
            menuItems={menuItems} />
    )
}

export default MainMenu
